const GlobalFullCalendar = function() {

    const _initGlobalCalendar = function(conf) {
        if (typeof FullCalendar == 'undefined') {
            console.warn('Warning - Fullcalendar files are not loaded.');
            return;
        }
        
        const calendarGlobalElement = document.querySelector('.calendar-modal');

        if(calendarGlobalElement) {
            const calendarGlobalInit = new FullCalendar.Calendar(calendarGlobalElement, {
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                initialDate: moment().format('YYYY-MM-DD'),
                navLinks: true, // can click day/week names to navigate views
                nowIndicator: true,
                weekNumberCalculation: 'ISO',
                editable: conf.editable,
                selectable: true,
                direction: document.dir == 'rtl' ? 'rtl' : 'ltr',
                dayMaxEvents: true, // allow "more" link when too many events
                events: conf.events,
                eventClick: function(calEv,jsEv,view){
                    Do.Ajax('/calendar/api/event',{
                        mode:'collapse',
                        uuid:calEv.event.id
                    });
                },
            });

            calendarGlobalInit.render();

        }

    };

    return {
        init: function(c) {
            _initGlobalCalendar(c);
        }
    }
}();

var paintModalCalendar = function( response ){
    GlobalFullCalendar.init(response.conf);
};

var revealCalendarEvent = function( response ){
    $('.calendar-modal').prepend(response.body);
    $('.cal-supermodal .card-footer .close').on('click',function(){
        $('.cal-supermodal').remove();
    });
};

document.addEventListener('DOMContentLoaded', function() {
    $('#calendar-modal').on('show.bs.modal',function(){
        Do.Ajax('/calendar/api/modal',{});
    });
});
